import React, { useRef } from "react";
import { CarrersSection } from "../atoms/CarrersSection";
import { CarrersHero } from "../atoms/CarrersHero";
import AvailableJobs from "../atoms/carrersAvalible";

export const Careers: React.FC = () => {
  const contentRef = useRef<HTMLDivElement>(null);

  const scrollTo = (ref: React.RefObject<HTMLDivElement>) => {
    ref.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <div className="h-[100svh] w-full overflow-y-scroll snap-y snap-always scroll-smooth overscroll-contain touch-pan-y scroll-pt-20 bg-black text-white">
      {/* Hero */}
      <section className="snap-start flex-none h-[100svh] w-full flex items-center justify-center">
        <CarrersHero
          scrollTo={scrollTo}
          goToSelectionRef={contentRef}
          goToSelectionRef2={contentRef}
        />
      </section>

      {/* Contenido */}
      <section
        ref={contentRef}
        className="snap-start flex-none min-h-[120svh] w-full flex items-start justify-center py-8 md:py-12"
      >
        <CarrersSection />
      </section>

      <section
        ref={contentRef}
        className="snap-start flex-none h-[100svh] w-full flex items-center justify-center"
      >
        <AvailableJobs />
      </section>
    </div>
  );
};

export default Careers;
